var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 19H13C13 19.5304 12.7893 20.0391 12.4142 20.4142C12.0391 20.7893 11.5304 21 11 21C10.4696 21 9.96085 20.7893 9.58578 20.4142C9.2107 20.0391 8.99999 19.5304 8.99999 19ZM20 17V18H1.99999V17L3.99999 15V9C3.99999 5.9 6.02999 3.17 8.99999 2.29V2C8.99999 1.46957 9.2107 0.960859 9.58578 0.585786C9.96085 0.210714 10.4696 0 11 0C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2V2.29C15.97 3.17 18 5.9 18 9V15L20 17ZM16 9C16 7.67392 15.4732 6.40215 14.5355 5.46447C13.5978 4.52678 12.3261 4 11 4C9.67391 4 8.40214 4.52678 7.46445 5.46447C6.52677 6.40215 5.99999 7.67392 5.99999 9V16H16V9ZM18.75 1.19L17.33 2.61C18.1758 3.44542 18.8473 4.44042 19.3056 5.53732C19.7639 6.63422 20 7.8112 20 9H22C22 6.07 20.84 3.25 18.75 1.19ZM-1.15214e-05 9H1.99999C1.99999 6.6 2.95999 4.3 4.66999 2.61L3.24999 1.19C2.21787 2.21157 1.39906 3.42807 0.841131 4.76881C0.283203 6.10955 -0.00271515 7.54781 -1.15214e-05 9V9Z",
    fill: "#000FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.28ce223a3febb779eaf147ccdad94dc9.svg";
export { ForwardRef as ReactComponent };